import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Asset } from '../v2/components/Asset'
import { CMSLink } from '../v2/components/CMSLink'
import { Page } from '@telesoft/types/payload-types'
import cn from 'classnames'
import { motion } from 'framer-motion'
import React, { ReactElement, ReactNode } from 'react'

interface DProps {
  text: string
  description: string
  image: any
  isSingular: boolean
  isButton: boolean
  link: any
}

interface RProps {
  title: string
  items: any
}

export function DiagramItem({ text, description, image, isSingular, isButton, link }: DProps) {
  return (
    <ButtonOrDiv isSingular={isSingular} link={link} isButton={isButton}>
      {description && (
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="tooltip top-0 left-0"
        >
          {description}
        </motion.span>
      )}
      <Asset resource={image} width={156} height={156} />
      <Text variant="heading" className="my-4 text-black">
        {text}
      </Text>
    </ButtonOrDiv>
  )
}

export function RowItem({ title, items }: RProps) {
  const isSingular = items.length > 1 ? false : true
  return (
    <>
      <div className="col-span-full border-b border-black border-dashed py-8">
        <Text variant="mediumHeading" className="text-center">
          {title}
        </Text>
      </div>
      {items &&
        items.map((item: any) => {
          return (
            <DiagramItem
              key={`diagram--item--${item.title}`}
              text={item.title}
              description={item.description}
              isSingular={isSingular}
              image={item.image}
              isButton={item.isButton || false}
              link={item.link}
            />
          )
        })}
    </>
  )
}

function ButtonOrDiv({
  children,
  isButton,
  link,
  isSingular,
}: {
  children: ReactNode
  isButton: boolean
  link: any
  isSingular: boolean
}) {
  return isButton ? (
    <CMSLink
      showLabel={false}
      className={cn(
        `has-tooltip relative flex p-4 lg:p-8 flex-col justify-center items-center hover:bg-accent-1 transition-colors duration-300`,
        {
          'col-span-4': !isSingular,
          'col-span-full': isSingular,
        },
      )}
      {...link}
    >
      {children}
    </CMSLink>
  ) : (
    <div
      className={cn(
        `has-tooltip relative flex p-4 lg:p-8 flex-col justify-center items-center hover:bg-accent-1 transition-colors duration-300`,
        {
          'col-span-4': !isSingular,
          'col-span-full': isSingular,
        },
      )}
    >
      {children}
    </div>
  )
}

export type DiagramClusterBlockTypes = Extract<Page['blocks'][0], { blockType: 'diagram-cluster' }>

function DiagramCluster(block: DiagramClusterBlockTypes): ReactElement {
  const { rows } = block

  return (
    <Container>
      <Grid>
        {rows &&
          rows.map((row: any, i: number) => {
            const { items } = row
            return <RowItem key={`row--item--${i}`} title={row.title} items={items} />
          })}
      </Grid>
    </Container>
  )
}

export default DiagramCluster
